import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { Button, Paper, Typography } from "@mui/material"
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Swal from "sweetalert2"
import { useState, useRef } from "react"
import { Pencil, Trash2 } from 'lucide-react'

import { UpdateLinkButtonModal } from "../../../../../pages/studio/tabs/links/modals/linkbutton/UpdateLinkButtonModal"
import { LinkButton } from "../../../../../model/LinkButton"

export function LinkButtonStudio({ uuid, id, title, url, onUpdate, onDelete, moneyType = '', onSetMoneyType, isPro }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: uuid })
    const [open, setOpen] = useState(false)
    const clickTimeoutRef = useRef(null)

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    const handleUpdateLink = async (updatedLink) => {
        const newLinkButton = new LinkButton(
            uuid,
            id,
            updatedLink.newTitle,
            updatedLink.newUrl,
            ""
        )
        onUpdate(newLinkButton)
        handleClose()
    }

    const handleDelete = () => {
        Swal.fire({
            title: `Delete Link '${title}'?`,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "DELETE",
            confirmButtonColor: "red",
        }).then((result) => {
            if (result.isConfirmed) {
                onDelete(uuid)
            }
        })
    }

    const style = {
        background: '#f8f8f8',
        borderRadius: '24px',
        marginTop: '1.2rem',
        marginBottom: '1rem',
        padding: '.6rem .3rem',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto',
        border: '1.2px solid #ccc',
        transition,
        transform: CSS.Transform.toString(transform),
    }

    const handleMouseDown = (e) => {
        clickTimeoutRef.current = setTimeout(() => {
            clickTimeoutRef.current = null
        }, 200)
    }

    const handleMouseUp = (e, action) => {
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current)
            action()
        }
    }

    return (
        <>
            <Paper
                elevation={3}
                ref={setNodeRef}
                style={style}
            >
                <div {...attributes} {...listeners} style={{ padding: '0 8px', cursor: 'grab', touchAction: 'none', alignSelf: 'center' }}>
                    <MoreVertIcon
                        fontSize="large"
                        sx={{
                            color: "#333",
                            padding: '.4rem',
                            m: 0,
                        }}
                    />
                </div>

                <div style={{
                    overflow: 'hidden',
                    padding: '0 8px'
                }}>
                    <Typography
                        variant="subtitle1"
                        component="h6"
                        sx={{
                            fontWeight: 600,
                            fontFamily: 'Catamaran',
                            textAlign: 'left',
                            textTransform: 'none',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: '110%'
                        }}
                    >
                        {title}
                        {moneyType && (
                            <span style={{
                                marginLeft: 8, fontSize: '.62em', fontWeight: 700, verticalAlign: 'middle',
                                color: '#15803d', background: '#e8f7ee', borderRadius: 6, padding: '2px 6px',
                                textTransform: 'none', whiteSpace: 'nowrap',
                            }}>
                                {moneyType.charAt(0) + moneyType.slice(1).toLowerCase()}
                            </span>
                        )}
                    </Typography>
                    <Typography
                        variant="body1"
                        component="p"
                        sx={{
                            fontWeight: 500,
                            fontFamily: 'Catamaran',
                            textAlign: 'left',
                            color: 'text.gray',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {url}
                    </Typography>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    padding: '0 8px'
                }}>
                    <Button
                        variant="text"
                        onMouseDown={handleMouseDown}
                        onMouseUp={(e) => handleMouseUp(e, handleOpen)}
                    >
                        <Pencil style={{ height: "20px", color: '#000' }} />
                    </Button>
                    <Button
                        variant="text"
                        onMouseDown={handleMouseDown}
                        onMouseUp={(e) => handleMouseUp(e, handleDelete)}
                    >
                        <Trash2 style={{ height: "20px", color: '#000' }} />
                    </Button>
                </div>
            </Paper>

            <UpdateLinkButtonModal
                open={open}
                onClose={handleClose}
                onUpdateLink={handleUpdateLink}
                title={title}
                url={url}
                moneyType={moneyType}
                isPro={isPro}
                onMoneyTypeChange={(type) => onSetMoneyType?.(uuid, type)}
            />
        </>
    )
}
